import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

export const ErrorToolTip = withStyles(() => ({
    tooltip: {
        classKey: 'error-tooltip',
        backgroundColor: '#F8D7DA !important',
        color: '#721C24 !important',
        display: 'flex !important',
        alignItems: 'center !important'
    },
    arrow: {
        color: "#F8D7DA !important",
    }
}))(Tooltip);